<template>
    <!-- All of these event listeners are here to speed up initial loading.  Map node dropdown initialization was taking quite awhile for more complex projects. -->
    <b-row no-gutters @mouseenter="shouldInitMapNodes = true" @touchmove="shouldInitMapNodes = true" @touchstart="shouldInitMapNodes = true" @input="shouldInitMapNodes = true">
        <b-row 
            no-gutters 
            v-if="timeline" 
            @click="clickEnter" 
            :class="checkTimelineRead(timelineid) && !checkTimelineCopying(timelineid) ? 'timeline-listing-root' : 'timeline-listing-root-disabled'"
        >
            <div class="sidebar"/>
            <div class="d-flex align-items-middle flex-column" style="height: 100%; width: 93%;">
                <div class="p-2">
                    <b-row style="height: 70px" class="list-content">
                        <best-fit-text 
                            role="heading" 
                            aria-level="5" 
                            style="color: #343B3F; margin: auto 0 auto 20px;"
                        >
                            {{timeline.name}}
                        </best-fit-text>
                        <p 
                            v-if="checkTimelineCopying(timelineid)"
                            style="color: #7c6231; margin-top: auto; margin-bottom: auto; text-align: center"
                        >
                            Copying...
                        </p>
                        <p 
                            v-else-if="!checkTimelineRead(timelineid)"
                            style="color: #7c6231; margin-top: auto; margin-bottom: auto; text-align: center"
                        >
                            (no access)
                        </p>
                        <p 
                            v-else-if="!checkTimelineWrite(timelineid)" 
                            style="color: #7c6231; margin-top: auto; margin-bottom: auto; text-align: center"
                        >
                            (view only)
                        </p>
                        <b-btn 
                            v-if="checkTimelineRead(timelineid) && !checkTimelineCopying(timelineid)" 
                            style="height: 100%; width: 100%; background-color: Transparent; border: none; padding: 0;" 
                            @click="clickEnter" 
                            v-b-tooltip.focus="'enter timeline'" 
                            aria-label="enter timeline"
                        >
                        </b-btn> <!-- this button is for tabbing / screen reader / ADA -->
                    </b-row>
                </div>
                <div class="p-2 align-self-center">
                    <b-row class="list-content">
                        <p style="color: #4d535e; margin-top: 22px; margin-bottom: 2px; height: 24px; font-size: 21px; font-weight: 500">
                            {{(minTime != null && maxTime != null) ? `${minTime.getUTCFullYearBCString()} - ${maxTime.getUTCFullYearBCString()}` : ''}}
                        </p>
                    </b-row>
                </div>
                <div class="p-2 align-self-center" style="margin-top: -2px">
                    <b-row class="list-content">
                        <b-dropdown v-if="hasMapNodes" :disabled="!checkTimelineAdmin(timelineid)" @shown="dropdownVisible=true" @hidden="dropdownVisible=false" id="dropdown-1" :text="currentMapNode ? currentMapNode.name : 'None'" variant="outline-dark" aria-label="map pins dropdown menu">
                            <b-dropdown-item :key="-1" @click="changeMapNode(-1)" v-on:click.stop>None</b-dropdown-item>
                            <template v-if="shouldInitMapNodes">
                                <!--shouldInitMapNodes-->
                                <b-dropdown-item v-for="mapNode in this.mapNodes.values()" :key="mapNode.nodeid" @click="changeMapNode(mapNode.nodeid)" v-on:click.stop>{{mapNode.name}}</b-dropdown-item>
                            </template>
                        </b-dropdown>
                    </b-row>
                </div>
                <div class="mt-auto p-2">
                    <div class="d-flex justify-content-between">
                        <b-btn 
                            v-b-tooltip="'comments'" 
                            v-on:click.stop 
                            @click="showModal('commentsModal')" 
                            aria-label="comments" 
                            style="background-color: Transparent; border: none; padding: 0;"
                        >
                            <img variant="light" class="icon-button" src="@/assets/icons/chat.png"/>
                        </b-btn>
                        <b-btn 
                            v-b-tooltip="'edit users'" 
                            v-if="checkTimelineAdmin(timelineid) && !checkTimelineCopying(timelineid)" 
                            v-on:click.stop 
                            @click="showModal('userEditModal')" 
                            aria-label="edit users" 
                            style="background-color: Transparent; border: none; padding: 0;"
                        >
                            <img class="icon-button" src="@/assets/icons/multiple-users-silhouette.png"/>
                        </b-btn>
                        <b-btn 
                            v-b-tooltip="'timeline description'" 
                            v-on:click.stop 
                            @click="showModal('dataModal')" 
                            aria-label="timeline description" 
                            style="background-color: Transparent; border: none; padding: 0;"
                        >
                            <img class="icon-button" src="@/assets/icons/information_solid_img.png"/>
                        </b-btn>
                        <b-btn 
                            v-b-tooltip="'copy timeline'" 
                            v-if="checkTimelineWrite(timelineid) && !checkTimelineCopying(timelineid)" 
                            v-on:click.stop @click="showModal('copyModal')" 
                            class="icon-button-nocol" 
                            variant="cliovis-blue-dark" 
                            style="margin: 5px; font-size: 95%;" 
                            aria-label="copy timeline"
                        >
                            <i class="fas fa-copy" style="margin-right: 0px"></i>
                        </b-btn>
                        <b-btn 
                            v-b-tooltip="'change folder'" 
                            v-if="checkTimelineAdmin(timelineid) && !checkTimelineCopying(timelineid)"
                            v-on:click.stop @click="showModal('changeFolderModal')" 
                            class="icon-button-nocol" 
                            variant="cliovis-blue-dark" 
                            style="margin: 5px; font-size: 95%;" 
                            aria-label="change folder"
                        >
                            <i class="fas fa-folder" style="margin-right: 0px"></i>
                        </b-btn>
                        <b-btn 
                            v-b-tooltip="'delete timeline'" 
                            v-if="checkTimelineAdmin(timelineid) && !checkTimelineCopying(timelineid)" 
                            v-on:click.stop @click="showModal('deleteModal')" 
                            class="icon-button-nocol" 
                            variant="danger" 
                            style="margin: 5px; font-size: 95%;" 
                            aria-label="delete timeline"
                        >
                            <i class="fas fa-trash" style="margin-right: 0px"></i>
                        </b-btn>
                    </div>
                </div>
            </div>
        </b-row>
        <template v-if="modalsInitialized">
            <b-modal ref="dataModal" size="lg" :centered="true" :title="'Description of ' + timeline.name" :hide-footer="true">
                <p v-if="timeline.description != null && timeline.description.length > 0">{{timeline.description}}</p>
                <p v-else>This timeline has no description.</p>
            </b-modal>
            <b-modal ref="commentsModal" size="lg" :centered="true" :title="'Comments for ' + timeline.name" :hide-footer="true">
                <p v-if="timeline.comments != null && timeline.comments.length > 0">{{timeline.comments}}</p>
                <p v-else>This timeline has no comments.</p>
            </b-modal>
            <b-modal ref="userEditModal" size="wide-3" :centered="true" title="Timeline Permissions Editor" :hide-footer="true">
                <timeline-permissions :timeline="timeline"/>
            </b-modal>
            <b-modal ref="copyModal" size="lg" :centered="true" title="Copy Timeline" :hide-footer="true">
                <timeline-copier :timeline="timeline" @close="$refs.copyModal.hide()"/>
            </b-modal>
            <b-modal ref="changeFolderModal" size="lg" :centered="true" title="Change Timeline Folder" @ok="(ev)=>{$refs.timelineMover.ok(ev)}" ok-variant="cliovis-blue-light">
                <timeline-mover ref="timelineMover" :timeline="timeline" @close="$refs.changeFolderModal.hide()"/>
            </b-modal>
            <b-modal ref="deleteModal" size="xl" :centered="true" :title="'Delete Timeline'" :hide-footer="true">
                <p>Are you sure that you want to delete this timeline?</p>
                <p>If so, type the Timeline name (<b>{{timeline.name}}</b>) in the field below, then click the 'Delete' button.</p>
                <b-form-input-limited :maxlength="50" v-model="deleteModalTitleInput" placeholder="Timeline title..." autofocus/>
                <h6 v-if="incorrectDeleteModalTitleInput" style="color:red;">Incorrect title, please try again</h6>
                <b-row class="list-content">
                    <b-btn @click="hideDeleteModal" style="margin: 2%; width: 46%;" variant='secondary'>Cancel</b-btn>
                    <b-btn @click="confirmTimelineDelete" style="margin: 2%; width: 46%;" variant='danger'>Delete</b-btn>
                </b-row>
            </b-modal>
        </template>
    </b-row>
</template>

<script>
import Vue from 'vue';
import Project from '@/models/Project.ts';
import { Permissions } from '@/models/PermissionEnum';
import ProjectServer from '@/models/ProjectServer';
import Mutations from '@/store/mutations';
import Timeline from '../../models/Timeline';
import { mapGetters } from 'vuex';
import { SendPacket } from '@/networking/SendPacket'
import { PacketType } from '@/models/Packet'
import BestFitText from "@/components/BestFitText.vue";
import BFormInputLimited from '@/components/input_limited/BFormInputLimited';
import { compareNamesRegardlessOfSpaces } from '@/util/StringUtil'
require('@/models/DateExtensionInterface.ts');
require('@/models/DateExtensionImplementation.ts');

// Components
import TimelinePermissions from './TimelinePermissions';
import TimelineCopier from './TimelineCopier';
import TimelineMover from './TimelineMover';

export default Vue.extend(
{
    components: 
    {
        BestFitText,
        TimelinePermissions,
        BFormInputLimited,
        TimelineCopier,
        TimelineMover
    },
    props:
    {
        timelineid : Number,
    },
    data()
    {
        return {
            dropdownVisible: false,
            modalsInitialized: false,
            deleteModalTitleInput: '',
            incorrectDeleteModalTitleInput : false,
            shouldInitMapNodes: false,
            nodeReload: false,
            unsubscribeFromMutations: null,
        }
    },
    computed: 
    {
        ...mapGetters([
            'checkTimelineCopying',
            'checkTimelineAdmin',
            'checkTimelineWrite',
            'checkTimelineRead',
            'timelines',
            'mapNodes',
            'mapToTimeline',
            'nodes'
        ]),
        hasMapNodes()
        {
            for(let k of this.mapNodes)
            {
                return true;
            }
            return false;
        },
        timeline()
        {
            return this.timelines.get(this.timelineid);
        },
        currentMapNode()
        {
            for (const kvp of this.mapToTimeline.entries())
            {
                let timelines = kvp[1];
                if (timelines.includes(this.timeline.id))
                {
                    return this.mapNodes.get(kvp[0]);
                }
            }
        },
        timelinenodes()
        {
            let tl = this.timeline;
            let tlnodes = [];
            if (tl != null && tl.nodeIDs.length > 0)
            {
                for (const nodeid of tl.nodeIDs)
                {
                    // console.log(nodeid);
                    tlnodes.push(this.nodes.get(nodeid));
                }
            }
            return this.nodeReload ? tlnodes : tlnodes;
        },
        minTime()
        {
            let min = null;
            // console.log(this.timelinenodes);
            for (const node of this.timelinenodes)
            {
                if (min == null || node.dateStart < min)
                {
                    min = node.dateStart;
                }
            }
            return min;
        },
        maxTime()
        {
            let max = null;
            for (const node of this.timelinenodes)
            {
                if (max == null || node.dateEnd > max)
                {
                    max = node.dateEnd;
                }
            }
            return max;
        }
    },
    methods: 
    {
        showModal(name)
        {
            if (!this.modalsInitialized)
            {
                this.modalsInitialized = true;
                this.$nextTick(() =>
                {
                    this.$refs[name].show();
                });
                return;
            }
            this.$refs[name].show();
        },
        notImplemented()
        {
            alert('Not implemented');
        },
        clickEnter()
        {
            if (this.dropdownVisible) return;
            if (!this.checkTimelineRead(this.timelineid) || this.checkTimelineCopying(this.timelineid)) return;
            this.$router.push(`/app/project/timeline/${this.timeline.id}`);
        },
        changeMapNode(mapnodeid)
        {
            this.$store.commit(Mutations.setMapToTimeline, { 'mapnodeid': mapnodeid, 'timelineid': this.timeline.id });
            // send to server!
            SendPacket(PacketType.TimelineChangeMapPin,
            {
                timelineid: this.timelineid,
                mapnodeid: mapnodeid
            });
        },
        hideDeleteModal()
        {
            this.$refs.deleteModal.hide();
            this.incorrectDeleteModalTitleInput = false;
        },
        confirmTimelineDelete()
        {
            if (compareNamesRegardlessOfSpaces(this.timeline.name, this.deleteModalTitleInput))
            {
                setTimeout(() => {
                    this.$nextTick(() =>
                        {
                            this.$bvToast.toast(this.deleteModalTitleInput + ' has been deleted.',
                            {
                                title: 'Timeline Deleted',
                                variant: 'default',
                                autoHideDelay: 5000
                            });
                        });
                }, 50);

                SendPacket(PacketType.TimelineDelete,
                {
                    timelineid: this.timeline.id
                });
                this.$store.commit(Mutations.deleteTimeline, { timelineid : this.timeline.id });
                this.hideDeleteModal();
            }
            else
            {
                this.incorrectDeleteModalTitleInput = true;
            }
        }
    },
    mounted()
    {
        this.unsubscribeFromMutations = this.$store.subscribe((mutation, state) =>
        {
            if (mutation.type === Mutations.addTimelineNode && mutation.payload.timelineid === this.timeline.id)
            {
                this.nodeReload = !this.nodeReload;
            }
        });
    },
    onDestroy()
    {
        this.unsubscribeFromMutations();
    }
})
</script>

<style lang="scss" scoped>
.timeline-listing-root
{
    transition: 300ms;
    height: 260px;
    width: 285px;
    background-color: #fdfaf9;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.3);
    margin-right: 0px;
    margin-left: 33px;
    margin-top: 25px;
    margin-bottom: 10px;
    cursor: pointer;
    
    .list-content
    {
        display: block;
        margin-top: auto;
        margin-bottom: auto;
    }
}

.timeline-listing-root-disabled
{
    height: 260px;
    width: 276px;
    background-color: #efeceb;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.3);
    margin-right: 0px;
    margin-left: 33px;
    margin-top: 25px;
    margin-bottom: 10px;
    
    .list-content
    {
        display: block;
        margin-top: auto;
        margin-bottom: auto;
    }
}

.timeline-listing-root:hover
{
    z-index: 200;
    transition: 200ms;
    transform: scale(1.025);
    background-color: #f8f5f4;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.3);
}

.icon-button
{
    margin: 5px; 
    height: 32px; 
    width: 32px;
    padding: 5px;
    border-radius: 100%;
    background-color: #24457a;
}

.icon-button-nocol
{
    margin: 5px; 
    height: 32px; 
    width: 32px;
    padding: 4px;
    border-radius: 100%;
}

.icon-button:hover
{
    background-color: #396aba;
}

.sidebar
{
    width: 5px;
    background-color: #B48E48;
    margin-right: 5px;
}

#dropdown-1 /deep/ .dropdown-menu {
    max-height: calc(90vh - 175px);
    overflow-y: auto;
  }
</style>
